import { doc, setDoc } from "@firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateResult = async (ResultDocumentID, ResultObject, uid) => {
  try {
    const ResultDocument = doc(db, "Results", ResultDocumentID);

    const data = HelperForMetaData({
      ...ResultObject,
      uid: uid,
    });
    await setDoc(ResultDocument, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }

  // try {
  //   const ExamsCollection = collection(db, "Results");

  //   const data = HelperForMetaData({
  //     ...ResultObject,
  //     uid: uid,
  //   });
  //   await addDoc(ExamsCollection, data);
  //   return true;
  // } catch (error) {
  //   console.log(error);
  //   return false;
  // }
};

export default CreateResult;
